/* eslint-disable */
/**
 * @type{Object} { prefix: http前缀, wsPrefix: ws前缀 }
 * @example
 *  {
 *    prefix: "http://localhost:7000", 
 *    wsPrefix: "ws://localhost"
 *  }
 */
const baseInfo = {
  prefix : `${window.location.protocol}//${window.location.host}`,
  wsPrefix : `${window.location.protocol === "https:" ? "wss:" : "ws:"}//${window.location.host}`
}


const baseUrl = `${baseInfo.prefix}/api/iobp/`
// // 本地联调用
// const baseUrl = `${baseInfo.prefix}/`
const FileUploadBase_entry = `${baseInfo.prefix}/file/`
const FileThumbBase_entry = `${baseInfo.prefix}/file/`
const FileUploadBase = `${baseInfo.prefix}/file/`
const FileThumbBase = `${baseInfo.prefix}/file/`
const domain = window.location.hostname
const security = true
// // // 本地联调用
// const security = false
const downloadTimeout = 60 * 60 * 1000
const wsIp = `${baseInfo.wsPrefix}/ws/iobp`
// // 本地联调用
// const wsIp = `ws://192.168.22.240:7020/ws/iobp`

const redirectBaseUrl = `${baseInfo.prefix}/`

const publicKey = `-----BEGIN RSA PUBLIC KEY-----
MIIBCgKCAQEAqvZKboDD5q5uBDGnqzC9W9SdxBye1wWgqvjfkHt0ao+ldr1nG+HV
6YAL61DCju37ayeyMdMjdXhtowziQzMsIaFeuHN4951cEDrlTrLEatPTkPyz0Yax
IUMuXrLAHZ5WAa59jKeF+iCoYDCUgHl5dpn00tIUXtKmgSnz5zEDLeWO/yUe1FWA
3WShhXGAL9Z/H7o8G3DqFYfV19e+gRNdMS5bojVosrvEDY7fJPRN9LqBJ6tE5YQv
DIPXN+sSSwgXB221W2iZ1KDM5By3LOh5aXEO16XMmKJbz2uQcXZJXC1Os4BLNM3A
OIuMo7tIPIXSASsQ096KnHhLiMdUZK88ZwIDAQAB
-----END RSA PUBLIC KEY-----`

const sigPrivateKey = `-----BEGIN PRIVATE KEY-----
MIIBVgIBADANBgkqhkiG9w0BAQEFAASCAUAwggE8AgEAAkEA5Pvl9r1zVIXbgkBG
BYb+rZciDJduOpUuseybdt/HHyHeFQ1VgBSdEYYXYq+cN07WEfljJ87/oDYF86ua
FqqlQQIDAQABAkEAtdfpRuoqhYwLx0NdmBQdeiOUUaWMTw+b1oZM67lIe0o73SUC
XdEDGv9XszezfXcOdz1Tf8U42HjXuoQhK7wGtQIhAP/h9JiKP6ErK8ZszLIVMqEx
pYArziIX70IJ2Uj1JBOPAiEA5RbI1tbMGdm4FI378qliiAC9Isz51VWLlWEq5sgl
Ei8CIQCo9YBWwOKm/ySWjvzSkiCuQ2Pur/4akQdQ6cPp4sSBjQIhAKpsQsigToHE
l86iuZWSMPygIBPtjMYJt6dO+81ngzx9AiBK5HBMaSYgmaHpekxll3OlTi0qZoG0
ehYjF/SbW4ToKA==
-----END PRIVATE KEY-----
`

const resAesKey = 'sUzwj3pTgtu266I/'

 // JAccount统一认证的配置
// const client_id = "GFxTlkHvM5lBmjUlLfzB"
// const client_secret = "7F1FB58A1F6EC120F81A1320CBD9CDD6252CF7EF45FE432A"
const redirect_uri = redirectBaseUrl + "platform/login"

export default {
  baseUrl: baseUrl,
  FileUploadBase_entry: FileUploadBase_entry,
  FileThumbBase_entry: FileThumbBase_entry,
  FileUploadBase: FileUploadBase,
  FileThumbBase: FileThumbBase,
  domain: domain,
  publicKey,
  sigPrivateKey,
  resAesKey,
  security: security,
  downloadTimeout: downloadTimeout,
  wsIp: wsIp,
  // JAccount统一认证的配置
  // client_id: client_id,
  // client_secret: client_secret,
  redirect_uri: redirect_uri,
  redirectBaseUrl: redirectBaseUrl,
}



// WEBPACK FOOTER //
// ./src/config/axiosConf.js